import type { StaticEntityType } from "@config";
import { Element } from "@library-containers/layers";
import { groupEntityWidth } from "@library/shared";
import { NARROW_MOBILE_MEDIA_OFFSET } from "@library/static/combo/options/array/utils/getMobileMediaWidthPercent";
import { GroupView } from "./Group.view";

/** Mobile width % for media in the smaller column of a split-ratio combo (e.g. SideBySide 1/3). */
const SMALLER_COLUMN_MOBILE_MEDIA_WIDTH = 30;

export const GroupLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { children, settings, id, layers } = entity;
  const groupWidth = groupEntityWidth(layers);
  const isNarrowCombo = layers?.combo?.settings?.maxWidth === "narrow";
  const isSmallerColumn = Number(groupWidth) < 50;
  const comboMobileMediaWidth = isSmallerColumn
    ? SMALLER_COLUMN_MOBILE_MEDIA_WIDTH -
      (isNarrowCombo ? NARROW_MOBILE_MEDIA_OFFSET : 0)
    : undefined;
  return (
    <GroupView
      entity={{
        ...entity,
        settings: {
          ...entity.settings,
          mediaOrder,
          groupWidth,
          index: groupIndex(layers),
          comboMobileMediaWidth,
        },
      }}
    >
      {children.map((child, index) => (
        <Element
          key={child.id}
          entity={{
            ...child,
            layers: {
              ...(entity.layers || {}),
              group: { settings, id, index, comboMobileMediaWidth },
            },
          }}
        />
      ))}
    </GroupView>
  );
};

const mediaOrder = (children: StaticEntityType[]) => {
  if (children.length !== 1) return 1;
  if (
    children[0].settings.name === "Image" ||
    children[0].settings.name === "Video" ||
    children[0].settings.name === "Charts"
  )
    return 0;
  return 1;
};

const groupIndex = (layers: Record<string, any> | undefined) => {
  if (!layers) return 0;
  return layers.set.index || 0;
};
